import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { JobService } from '../services/job.service';
import { User } from './dto/user';
import { SurveyDetails } from './dto/survey';
import { CriteriaDetails } from './dto/criteria';
import { OfferDetails } from './dto/offer-details';
import { AnswerDetails } from './dto/answer-details';
import { CriteriaOptionDetails } from './dto/criteria-options-details';
import { CoefDetails } from './dto/coef-details';
import { OffersOrderMatch } from './dto/offers-order-match';
import { OffersCompleteLevel } from './dto/offers-complete-level';
import { OffersResult } from './offer-result-details';

@Injectable()
export class OffersModel {
    email: string;
    user_data: any;
    vision_title: string;
    offer_selected: OfferDetails;
    answers_selected: Array<AnswerDetails> = [];
    coefs: Array<CoefDetails> = [];

    constructor(private jobService: JobService, private offersResult: OffersResult) {
        const user = JSON.parse(localStorage.getItem('user_data'));
        const user_id = user.id;
        this.email = user.email;
        this.getCoefs();

    }

    getCoefs() {
        const coefsInStorage = JSON.parse(localStorage.getItem('coefs'));
        if (coefsInStorage && coefsInStorage !== 'null') {
            this.coefs = coefsInStorage;
        } else {
            this.getCoef().subscribe(cofs => {
                this.coefs = cofs.allCoefs;
                localStorage.setItem('coefs', JSON.stringify(this.coefs));
            });
        }
    }
    getCoef() {
        return this.jobService.getCoefs().map(cofs => cofs);
    }

    getOfferMatchLevel(offer: OfferDetails) {
        let perc = 0;
        this.offer_selected = offer;
        this.answers_selected = this.offer_selected.answers;
        const x_answer = this.answers_selected.filter(x => x.option != null && x.option.importance === 4);
        if (x_answer.length > 0) {
            perc = 0;
        } else {
            let crit_total = 0;
            let crit_coef_total = 0;
            const criteria_list = Array.from(new Set(this.answers_selected)).map((itemInArray) => itemInArray.criteria);
            criteria_list.forEach(criteria => {
                const critId = criteria.id;
                const critCoef = this.coefs.filter(x => x.importance === criteria.importance)[0].coef;
                const options1_DESC = this.answers_selected.filter(x => x.option && x.option.importance === 1 && x.criteria.id === critId);
                const options2_SOU = this.answers_selected.filter(x => x.option && x.option.importance === 2 && x.criteria.id === critId);
                const options3_ACC = this.answers_selected.filter(x => x.option && x.option.importance === 3 && x.criteria.id === critId);
                const options1_total = options1_DESC.length;
                const options2_total = options2_SOU.length;
                const options3_total = options3_ACC.length;

                const DEC_Cof_2 = options1_total * critCoef * 2;
                const SOU_Cof_1 = options2_total * critCoef * 1;
                const ACC_Cof__2 = options3_total * critCoef * (-2);

                crit_total += DEC_Cof_2 + SOU_Cof_1 + ACC_Cof__2;
                crit_coef_total += critCoef;


            });

            perc = (25 / 100) * crit_total / crit_coef_total + (50 / 100);
        }
        return Observable.of(perc);
    }

    getOfferCriterias(offerId) {
        return this.jobService.getOfferDetails(offerId).map(data => {
            this.offer_selected = data.Offer;
            const criteria_list = Array.from(new Set(this.answers_selected)).map((itemInArray) => itemInArray.criteria);
            return criteria_list;
        });
    }

    getCompleteLevel(offer: OfferDetails, survey: SurveyDetails) {
        let perc = 0;
        this.offer_selected = offer;
        this.answers_selected = this.offer_selected.answers;
        const crit_total = 0;
        const crit_coef_total = 0;
        const survey_criterias = survey.criterias;
        const selected_criterias_list = Array.from(new Set(this.answers_selected)).map((itemInArray) => itemInArray.criteria);
        // get Coefs of survey_criterias
        let sum_survey_criterias = 0;
        let sum_selected_criterias = 0;
        survey_criterias.forEach(criteria => {
            const critCoef = this.coefs.filter(x => x.importance === criteria.importance)[0].coef;
            sum_survey_criterias += critCoef;
        });
        // get Coefs of selected_criterias
        selected_criterias_list.forEach(criteria => {
            const critCoef = this.coefs.filter(x => x.importance === criteria.importance)[0].coef;
            sum_selected_criterias += critCoef;
        });
        perc = sum_selected_criterias / sum_survey_criterias;
        return Observable.of(perc);
    }

    getCompleteResult(offerDetails: OfferDetails, offer: OffersOrderMatch, offerComplete: number, survey: SurveyDetails) {
        let survey_criterias: Array<CriteriaDetails> = [];
        survey_criterias = survey.criterias;
        const selected_criterias_list = Array.from(new Set(offerDetails.answers)).map((itemInArray) => itemInArray.criteria);
        const selected_ids: Array<string> = [];
        selected_criterias_list.forEach(selected_criteria => {
            selected_ids.push(selected_criteria.id);
        });
        const selected_criterias = survey_criterias.filter(x => selected_ids.includes(x.id));
        const completeResult: OffersCompleteLevel = {
            id: offer.id, title: offer.title, color: '', smile: '', match_percentage: offer.percentage, complete_percentage: 0,
            result_title: '', result_description: '', result_description_below: '', criterias: selected_criterias, answers: offer.answers
        };
        const match_percentage = offer.percentage;
        const complete_percentage = offerComplete;
        let searchValue = '';
        completeResult.complete_percentage = offerComplete;
        if (match_percentage === 0) {
            searchValue = 'all_x';
        } else if (complete_percentage < 50) {
            searchValue = '0_50_all';
        } else if (complete_percentage >= 50 && complete_percentage < 75) {
            if(match_percentage < 25){
                searchValue = '50_75_0_25';
            } else if (match_percentage >= 25 && match_percentage < 50) {
                searchValue = '50_75_25_50';
            } else if (match_percentage >= 50 && match_percentage < 75) {
                searchValue = '50_75_50_75';
            } else if (match_percentage >= 75 && match_percentage < 90) {
                searchValue = '50_75_75_90';
            } else if (match_percentage >= 90) {
                searchValue = '50_75_90_100';
            }
        } else if (complete_percentage >= 75 && complete_percentage < 90) {
            if(match_percentage < 25){
                searchValue = '75_90_0_25';
            } else if (match_percentage >= 25 && match_percentage < 50) {
                searchValue = '75_90_25_50';
            } else if (match_percentage >= 50 && match_percentage < 75) {
                searchValue = '75_90_50_75';
            } else if (match_percentage >= 75 && match_percentage < 90) {
                searchValue = '75_90_75_90';
            } else if (match_percentage >= 90) {
                searchValue = '75_90_90_100';
            }
        } else if (complete_percentage >= 90 && complete_percentage <= 100) {
            if(match_percentage < 25){
                searchValue = '90_100_0_25';
            } else if (match_percentage >= 25 && match_percentage < 50) {
                searchValue = '90_100_25_50';
            } else if (match_percentage >= 50 && match_percentage < 75) {
                searchValue = '90_100_50_75';
            } else if (match_percentage >= 75 && match_percentage < 90) {
                searchValue = '90_100_75_90';
            } else if (match_percentage >= 90) {
                searchValue = '90_100_90_100';
            }
        }
        const result_array = this.offersResult.getResult(searchValue);
        completeResult.color = result_array.color;
        completeResult.smile = result_array.smile;
        completeResult.result_title = result_array.title;
        completeResult.result_description = result_array.text;
        completeResult.result_description_below = result_array.text_below;

        return completeResult;
    }

    registerAfterEditJobs(jobId): Observable<any> {
        let stopCondition = false;
        return Observable.interval(1000)
            .takeWhile(() => !stopCondition)
            .map(i => {
                // This will be called every wait time until `stopCondition` flag is set to true
                this.jobService.getOfferDetailsAfterEdit(jobId).subscribe(resp => {
                    stopCondition = true;
                });
            });
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/offers.model.ts